/** Load failures worth retrying: network errors and 5xx, not invalid or expired links. */
export const isRetryableError = (err) => {
  const status = err?.response?.status;
  return !status || status >= 500;
};
